"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SVBBusinessDomain = props => {
  var _props$title, _props$description;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "View APIs (#)";
  const icon = props === null || props === void 0 ? void 0 : props.icon;
  const handleOnClick = props === null || props === void 0 ? void 0 : props.handleOnClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "business-domain-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph medium p-0 fw-normal business-domain-title-color text-capitalize"
  }, title), /*#__PURE__*/_react.default.createElement("img", {
    src: icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-1"
  }), /*#__PURE__*/_react.default.createElement("a", {
    onClick: handleOnClick,
    role: "button"
  }, /*#__PURE__*/_react.default.createElement("u", {
    className: "paragraph medium p-0 rl-font-black fw-bold font-family-roboto"
  }, description)));
};
var _default = SVBBusinessDomain;
exports.default = _default;